import ApiClient from '@/services/apiClient';

export default class AccessGroup {
    id;
    name;

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

    static constructFromObject(data, obj) {
        obj = obj || new AccessGroup();
        if (data) {
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.name = ApiClient.convertToType(data['name'], 'String');
        }
        return obj;
    }

    toString() {
        return this.name;
    }
}
